import { render, staticRenderFns } from "./categories_list.vue?vue&type=template&id=00f99e7a&"
import script from "./categories_list.vue?vue&type=script&lang=js&"
export * from "./categories_list.vue?vue&type=script&lang=js&"
import style0 from "./categories_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports